<template>
  <span>
    <el-button type="text" @click="openDetail">查看详情</el-button>
    <el-dialog
      :visible.sync="dialogVisible"
      title="发送详情"
      :modal="false"
      width="960px"
      top="9vh"
      append-to-body
    >
      <div v-if="rosterType === 0" style="font-size: 16px">
        由于医生未关注公众号、或医生数据已经被删除等原因导致无法发送。
      </div>
      <div v-if="rosterType === 1" style="font-size: 16px">
        由于粉丝未关注公众号、或粉丝数据已经被删除等原因导致无法发送。
      </div>
      <el-table v-if="rosterType === 0" :data="tableList" v-loading="tableLoading" height="600px">
        <el-table-column prop="UserId" label="编号"></el-table-column>
        <el-table-column prop="Name" label="姓名"></el-table-column>
        <el-table-column prop="UserCode" label="医生编码"></el-table-column>
        <el-table-column prop="Hospital" width="224px" label="医院"></el-table-column>
        <el-table-column prop="Department" label="科室"></el-table-column>
        <el-table-column prop="Title" label="职称"></el-table-column>
        <el-table-column prop="Status" label="能否发送">
          <template slot-scope="scope">
            {{ scope.row.Status | handleStatus }}
          </template>
        </el-table-column>
      </el-table>
      <el-table v-if="rosterType === 1" :data="tableList" v-loading="tableLoading" height="600px">
        <el-table-column prop="OpenId" label="OpenId"></el-table-column>
      </el-table>
      <div style="text-align: right">
        <el-pagination
          style="background-color: #ffffff; width: 100%"
          layout="total, prev, sizes, pager, next"
          :total="pageTotal"
          :page-sizes="g_pageSizesConfig"
          :page-size="pageSize"
          :current-page="pageIndex"
          @current-change="changePageIndex"
          @size-change="changePageSize"
        />
      </div>
      <div style="display: flex; justify-content: center">
        <el-button type="primary" style="width: 200px" @click="dialogVisible = false">
          确定
        </el-button>
      </div>
    </el-dialog>
  </span>
</template>

<script>
import { GetSendUserList } from '@/api/roster';
export default {
  name: 'PublishRosterDetail',
  filters: {
    handleStatus(status) {
      switch (status) {
        case 1:
          return '可发送';
        case 2:
          return '已删除';
        case 3:
          return '已取关';
        default:
          return '-';
      }
    },
  },
  props: {
    rosterId: {
      type: Number,
      default: -1,
    },
    appId: {
      type: String,
      default: '',
    },
    rosterType: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      tableList: [],
      pageSize: 10,
      pageIndex: 1,
      pageTotal: 1,
      tableLoading: false,
      dialogVisible: false,
    };
  },
  methods: {
    async getList() {
      this.tableLoading = true;
      try {
        const res = await GetSendUserList({
          PageIndex: this.pageIndex,
          PageSize: this.pageSize,
          RosterId: this.rosterId,
          AppId: this.appId,
        });
        this.pageTotal = res.Total;
        this.tableList = res.Users;
      } catch (e) {
        this.$message.error(e);
      }
      this.tableLoading = false;
    },
    openDetail() {
      this.dialogVisible = true;
      this.pageIndex = 1;
      this.getList();
    },
    changePageIndex(val) {
      this.pageIndex = val;
      this.getList();
    },
    changePageSize(val) {
      this.pageSize = val;
      this.getList();
    },
  },
};
</script>

<style scoped></style>
